import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// @dynamic
@Component({
  selector: 'sc-error-dialog',
  templateUrl: './sc-error-dialog.component.html',
  styleUrls: ['./sc-error-dialog.component.scss']
})
export class ScErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ScErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      errorMessage: {
        title: string;
        errorList: string[];
      };
      type: 'error' | 'warning';
    }
  ) {}
}
